import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { Mediator } from '@spotahome/soyuz-mediator';

import { formatPrice } from '@spotahome/soyuz-currency';

import { DSIcon } from '../../../base';

import { APPLY_ON_INCLUDED } from '../../constants/costs';

import { OPEN_INFORMATION_MODAL } from '../utils/constants';

import { ListingCostsShape } from '../../constants/shapes';

import Link from '../Link';

import { FREQUENCY_PRICE_DICTIONARY, ICONS_DICTIONARY } from './constants';

import IncludedBadge from './IncludedBadge';

import { isCustomCost } from './costHelpers';

import extraModalStyles from './Extra.module.scss';

import PaymentDetailsCard from './PaymentDetailsCard';

import styles from './ExtraServices.module.scss';

const isDescriptionKeyValid = type =>
  trans(`payment.timeline.cost.label.${type}.description`) !==
  `payment.timeline.cost.label.${type}.description`;

const ExtraServices = ({
  costs = {},
  currencyCode = 'EUR',
  isCollapsed = true
}) => {
  const handleCostClick = cost => e => {
    e.preventDefault();
    let price;
    const isIncluded = cost.applyOn === APPLY_ON_INCLUDED;
    if (cost.value && !isIncluded) {
      const formattedPrice = formatPrice(cost.value, currencyCode);
      const frequencyLabel =
        FREQUENCY_PRICE_DICTIONARY[cost.applyOn] ||
        FREQUENCY_PRICE_DICTIONARY[cost.frequency];

      price = frequencyLabel
        ? trans(frequencyLabel, { price: formattedPrice })
        : formattedPrice;
    }

    Mediator.publish(OPEN_INFORMATION_MODAL, {
      title: cost.name || (
        <p className={extraModalStyles.extra__title}>
          {ICONS_DICTIONARY[cost.type] && (
            <DSIcon name={ICONS_DICTIONARY[cost.type]} />
          )}
          <span className={extraModalStyles['extra__title-type']}>
            {trans(`payment.timeline.cost.label.${cost.type}`)}
          </span>
        </p>
      ),
      body: cost.description || (
        <>
          {!isCustomCost(cost.type) && isDescriptionKeyValid(cost.type) ? (
            <p className={extraModalStyles.extra__description}>
              {trans(`payment.timeline.cost.label.${cost.type}.description`)}
            </p>
          ) : null}
          {price ? (
            <p className={extraModalStyles.extra__price}>{price}</p>
          ) : null}
          {isIncluded ? (
            <IncludedBadge className={extraModalStyles.extra__price} />
          ) : null}
          <p
            dangerouslySetInnerHTML={{
              __html: trans('payment.timeline.cost.label.extra.ask-landlord')
            }}
          />
        </>
      )
    });
  };

  if (!(costs?.costs?.length > 0)) {
    return null;
  }

  return (
    <PaymentDetailsCard
      dataTest="payment-details.extra-services"
      footer={trans('payment.details.extra_services.subtitle')}
      isCollapsed={isCollapsed}
      title={trans('payment.details.extra_services.title')}
    >
      {() => (
        <ul className={styles['extra-services__list']}>
          {costs.costs.map((cost, index) => {
            const label = isCustomCost(cost.type)
              ? cost.name
              : trans(`payment.timeline.cost.label.${cost.type}`);
            const key = `${cost.type}-${index}`;

            const renderIcon = () =>
              ICONS_DICTIONARY[cost.type] ? (
                <DSIcon
                  className={styles['extra-services__item-icon']}
                  name={ICONS_DICTIONARY[cost.type]}
                />
              ) : null;

            return (
              <li key={key}>
                <Link
                  href="#"
                  className={styles['extra-services__item-button']}
                  onClick={handleCostClick(cost)}
                  underlined={false}
                >
                  {renderIcon()}
                  <span className={styles['extra-services__item-label']}>
                    {label}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </PaymentDetailsCard>
  );
};

ExtraServices.propTypes = {
  costs: ListingCostsShape,
  currencyCode: PropTypes.string,
  isCollapsed: PropTypes.bool
};

export default ExtraServices;
